import { signal } from "@preact/signals-react";
import { logToken } from "./login.signal";

export const catalogNo = signal(null);
export const catalogData = signal(null);
export const catalogSearchData = signal(null);

export async function fetchCatalog() {
  const url = "https://alguthmi.co/API/B2BAppAPI/fetchCatalog.php";
  const bearerToken = logToken.value;
  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      origin: "http://alguthmi.co",
    },
    body: JSON.stringify({}),
  };

  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error:", error);
  }
}

export async function fetchCatalogData(CATALOG_NUMBER) {
  const url = "https://alguthmi.co/API/B2BAppAPI/fetchCatalogData.php";
  const bearerToken = logToken.value;
  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      origin: "http://alguthmi.co",
    },
    body: JSON.stringify({
      CATALOG_NUMBER: CATALOG_NUMBER,
    }),
  };

  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error:", error);
  }
}

export async function fetchSearchCatalog(CATALOG_NUMBER) {
  const url = "https://alguthmi.co/API/B2BAppAPI/fetchSearchCatalog.php";
  const bearerToken = logToken.value;
  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      origin: "http://alguthmi.co",
    },
    body: JSON.stringify({ CATALOG_NUMBER }),
  };

  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error:", error);
  }
}
